export default "//cloud.imgsmail.ru/cloud.mail.ru/188971/img/build/plus32-from-spherum.png";